import { ArrowRightAltIcon, makeStyles } from '@freighthub/silhouette-core'
import cn from 'classnames'
import { QuoteRequestFormState } from 'features/BookingFlow'
import { placeToString } from 'features/Directory'
import { transportModesIconMap } from 'features/TransportPlan'
import { FC } from 'react'
import { useWatch } from 'react-hook-form'

import { cargoTypesIconMap } from '../BookingTemplatesList/cargoTypes'

const useStyles = makeStyles(() => ({
  root: {
    marginLeft: -6,
    marginBottom: 20,
  },
  row: {
    display: 'flex',
    alignItems: 'center',
  },
  label: {
    marginRight: 10,
  },
  icon: {
    flex: 'none',
    padding: 6,
    '& > svg': {
      width: 16,
      height: 16,
    },
  },
  locations: {
    flex: 1,
    justifyContent: 'flex-start',
    width: 'calc(100% - 150px)',
    maxWidth: 'calc(100% - 150px)',
  },
  location: {
    padding: 6,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}))

export const BookingTemplateRequestInfo: FC = () => {
  const classes = useStyles()

  const modes = useWatch<QuoteRequestFormState, 'modes'>({ name: 'modes' })
  const type = useWatch<QuoteRequestFormState, 'type'>({ name: 'type' })
  const origin = useWatch<QuoteRequestFormState, 'origin'>({ name: 'origin' })
  const destination = useWatch<QuoteRequestFormState, 'destination'>({ name: 'destination' })

  const originString = origin ? placeToString(origin) : ''
  const destinationString = destination ? placeToString(destination) : ''

  return (
    <div className={classes.root}>
      <div className={classes.row}>
        {modes.map((mode) => (
          <span key={mode} className={classes.icon}>
            {transportModesIconMap[mode]}
          </span>
        ))}
        <span className={classes.icon}>{cargoTypesIconMap[type]}</span>
        <span className={cn(classes.row, classes.locations)}>
          <span className={classes.location}>{originString}</span>
          <ArrowRightAltIcon />
          <span className={classes.location}>{destinationString}</span>
        </span>
      </div>
    </div>
  )
}
